<script setup lang="ts">
import HousingApplicationFinderInner from "./HousingApplicationFinderInner.vue";

const props = defineProps<{
  applicationGuid: string;
  isReadOnly?: boolean;
}>();

const emit = defineEmits<{
  (e: "closed"): void;
}>();

const drawerOpened = defineModel<boolean>({ required: true });

const handleCloseDrawer = () => {
  drawerOpened.value = false;
  emit("closed");
};
</script>
<template>
  <el-drawer
    :model-value="drawerOpened"
    direction="rtl"
    size="80%"
    class="housing-application-drawer form"
    :show-close="false"
    @closed="handleCloseDrawer"
  >
    <template #header="{ titleId, titleClass }">
      <h3 :id="titleId" :class="titleClass">Location Finder</h3>
      <el-button type="primary" @click="handleCloseDrawer"> Done </el-button>
    </template>

    <HousingApplicationFinderInner
      :application-guid="applicationGuid"
      :is-read-only="isReadOnly"
    />
  </el-drawer>
</template>
<style lang="less"></style>
